/**
 * @internal
 */
export const TRANSFORMER_API: { readonly VERSION: number } = {
	VERSION: 1,
};
